import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  AfterViewInit,
  ChangeDetectorRef,
  Injector,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Field, FormsServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-control-host',
  templateUrl: './controls.host.component.html',
  styleUrls: ['./controls.host.component.scss'],
})
export class ControlsHostComponent  extends AppComponentBase implements OnInit  {
  constructor(injector:Injector,
    private _formServiceProxy: FormsServiceProxy
  ) 
  {
    super(injector);
  }
  @Input() control!: Field;
  @Input() createdBy: number;
  _form: FormGroup;
  imageError: string;
  isImageSaved: boolean;
  cardImageBase64: string;

  fileBase64:string;
  isFileSaved: boolean;
  fileType: string;
  fileName: string;
  oldFileName: string;
  splitSymbolsBase64: string = "@%&";

  canDelete: boolean = true;

  @Input() set form(value: FormGroup) {
    this._form = value;
  }
  get form(): FormGroup {
    return this._form;
  }
  @Input() isReadOnly: boolean;
  @Output() blur = new EventEmitter();

  async ngOnInit() {
    this.validateCanDelete();
    if (
      this.control &&
      this.control.controlType === 'image'
    ) {
      this.handleImageControllType();
  }

    if (
      this.control &&
      this.control.controlType === 'file'
    ) {
      this.handleFileControllType();
    }
    if (
      this.control &&
      this.control.controlType === 'checkbox' && this.control.dataSetEnabled != true
    ) {
		this.form.get(this.control.id)?.value?.forEach((element) => {
			this.control.options.find((x) => x.id === element).value = 'true';
		});
    }
  }

  handleImageChange(item, fileInput: any) {
    this.imageError = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png'];
    const file = fileInput.target.files[0];
    this.fileName = file.name;
  
     // Check file format
      if (!allowedFormats.includes(file.type)) {
        this.imageError = 'Invalid file format. Only JPG, JPEG, and PNG are allowed.';
        this.cardImageBase64 = null;
        this.isImageSaved = false;
        alert(this.imageError);
        return false;
      }

      // Size Filter Bytes
      const max_size = 10000000;
      if (file.size > max_size) {
        this.imageError = 'Maximum size allowed is 10 MB';
        this.cardImageBase64 = null;
        this.isImageSaved = false;
        alert(this.imageError);
        return false;
      }
      
      if(this.oldFileName){
        this.deleteOldBlobFile(this.oldFileName);
      }

        const reader = new FileReader();
        reader.onload = (e: any) => {
            const image = new Image();
            image.src = e.target.result;
            const imgBase64Path = e.target.result;         
            this.cardImageBase64 = imgBase64Path ;
            this.isImageSaved = true;
            this.form.get(item).setValue(this.cardImageBase64+ this.splitSymbolsBase64 + this.fileName);
            this.blur.emit();
        };
       
        reader.readAsDataURL(fileInput.target.files[0]);
    }
}
openImageInNewTab(base64Image: string) {
  var image = new Image();
  image.src = base64Image;
  var w = window.open("");
        w.document.write(image.outerHTML);
}

removeImage(item) {
  this.cardImageBase64 = null;
  this.isImageSaved = false;
  this.deleteFormFiles(item);
}


handleFileChange(item: any, fileInput: any) {
  if (fileInput.target.files && fileInput.target.files[0]) {
    const allowedFormats = {
      'application/vnd.ms-excel': ['xls', 'xlsx'],
      'application/pdf': ['pdf'],
      'text/csv': ['csv']
    };
    const file = fileInput.target.files[0];
    this.fileName = file.name;
  
    // Check file format
    const fileExtension = file.name.split('.').pop();
    let isValidFormat = false;
    
    for (const mimeType in allowedFormats) {
      if (allowedFormats[mimeType].includes(fileExtension)) {
        isValidFormat = true;
        break;
      }
    }
  
    if (!isValidFormat) {
      this.isFileSaved = false;
      this.fileName = "";
      this.handleError(`Invalid file extension. Only xls, xlsx, pdf, and csv formats are allowed.`);
      return;
    }

    // Size Filter Bytes
    const max_size = 10000000;
    if (file.size > max_size) {
      this.handleError('Maximum size allowed is 10 MB');
      this.isFileSaved = false;
      return;
    }
    if(this.oldFileName){
      this.deleteOldBlobFile(this.oldFileName);
    }
    const reader = new FileReader();
        reader.onload = (e: any) => {
            const fileBase64Path = e.target.result;         
            this.fileBase64 = fileBase64Path;
            this.isFileSaved = true;
            this.form.get(item).setValue(this.fileBase64 + this.splitSymbolsBase64 + this.fileName);
            this.blur.emit();
        };
    reader.readAsDataURL(file);

  }
}

handleError(error: string) {
  // Display the error message
  alert(error);
}

removeFile(item) {
  // Reset the file-related properties
  this.fileBase64 = '';
  this.isFileSaved = false;
  this.fileType = '';
  this.deleteFormFiles(item)
}

  openFileInNewTab(base64Data: string) {
    const w = window.open('');
    w.document.write(`<embed src="${base64Data}" width="100%" height="100%" />`);
  }

  deleteFormFiles(item){
    const blobFileName = this.form.get(item).value;
    this.oldFileName = blobFileName;
    this.form.get(item).setValue('');
    if(this.control && !this.control.validations.some(val=> val.validationType === 'required')){
      this._formServiceProxy.deleteFormFile(blobFileName).subscribe();
      this.blur.emit();
    }
  }

  deleteOldBlobFile(item) {
    if (item && this._form.status.toLowerCase() !== 'valid' && item.startsWith('form_')) {
      this._formServiceProxy.deleteFormFile(item).subscribe();
    }
  }
  
  validateCanDelete(){
    if(this._form.status === "DISABLED"){
      this.canDelete = false;
      return;
    }
    if(this.createdBy && abp.session.userId != this.createdBy){
      this.canDelete = false;
    }
  }

  handleImageControllType() {
    let imageFromDb = this.form.get(this.control.id).value;
    if (imageFromDb && !(imageFromDb.trim() === "")) {
        this.cardImageBase64 = imageFromDb;
        if (this.cardImageBase64 !== "") {
          this.isImageSaved = true;
        }
    }
  }
  
  handleFileControllType() {
    let fileFromDb = this.form.get(this.control.id).value;
    if (fileFromDb && !(fileFromDb.trim() === "")) {
        this.fileBase64 = fileFromDb;
        if(this.fileBase64 != ""){
          let fileNameSplitted = fileFromDb.split(';base64,')[0];;
          this.fileName = fileNameSplitted.split('/').pop();
          this.isFileSaved = true;
        }
    }
  }


  get isValid() {
    return this.form.controls[this.control.id]?.invalid;
  }
  get isValidRegex() {
    if(this.control.validations){
      let res = "";
      this.control.validations.forEach((val)=>{
        if( val.validationType === "regex"){
          let regexp = new RegExp(val.value);
          let isValid = (this.form.controls[this.control.id].value)? regexp.test(this.form.controls[this.control.id].value): true;
          if(!isValid){
            res += this.l(val.message, this.control.label) + '\n';
          }
        }
      })
    return res;
    }
  }
  saveCheckData(item, evnt) {
    if (this.control && this.control.controlType === 'checkbox') {
      if(this.control.dataSetEnabled == true){
        let a = this.control.options.find((x) => x.display?.['fieldId'] === evnt.target.id);
        this.control.options.find((x) => x.display?.['fieldId'] === evnt.target.id).value = evnt
        .target.checked
        ? 'true'
        : 'false';
      if (!this.control.options.some((x) => x.value === 'true')) {
        this.form.get(item).setErrors({ something: true });
      }
      else {
        this.form
          .get(item)
          .setValue(
            this.control.options
              ?.filter((x) => x.value === 'true')
              .map((x) => x.display)
          );
      }
    }
    else{
      this.control.options.find((x) => x.id === evnt.target.id).value = evnt
        .target.checked
        ? 'true'
        : 'false';
      if (!this.control.options.some((x) => x.value === 'true')) {
        this.form.get(item).setErrors({ something: true });
      } else {
        this.form
          .get(item)
          .setValue(
            this.control.options
              ?.filter((x) => x.value === 'true')
              .map((x) => x.id)
          );
      }
    }
  }
    this.blur.emit();
  }

  public objectComparisonFunction = function( option, value ) : boolean {
    return option.display.fieldId === value?.fieldId;
  }

  public nullComparisonFunction  = function(option: any, value: any): boolean {
    return option === value;
  }

  saveSelectData(item, evnt) {
    if (this.control && (
        this.control.controlType === 'selectlist' ||
        this.control.controlType === 'radio'
        ) && 
      this.control.dataSetEnabled == true) {

      var val = {
        fieldId: evnt.display.fieldId,
        fieldValue: evnt.display.fieldValue,
        fieldDefinition: this.control.dataSet
      }
      if(this.control.controlType === 'radio'){
        const fieldId = this.form.get(this.control.id)?.value?.['fieldId'];
              const option = this.control.options.find((option) => option.display?.['fieldId'] === fieldId);
              if (option) {
                this.form.get(this.control.id)?.setValue(option);
              }
      }
      else{this.form.get(item).setValue(val);}
    }
    else {this.form.get(item).setValue(evnt);}
    this.blur.emit();
  }


  saveData() {
    this.blur.emit();
  }
}
